import { Component, OnInit } from '@angular/core';
import { UserService } from '@pages/users/services/user.service';
import { Observable } from 'rxjs';
import { User } from '@shared/modules/auth/classes/User';
import { UserRole } from '@shared/modules/auth/classes/UserRole';

@Component({
  selector: 'app-user-profile-header',
  templateUrl: './user-profile-header.component.html',
  styleUrls: ['./user-profile-header.component.scss'],
})
export class UserProfileHeaderComponent implements OnInit {
  me$: Observable<User>;
  manageUserRoles = [UserRole.SuperAdmin, UserRole.Admin];

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.me$ = this.userService.select('me');
  }
}
